export interface IException {
	Code: string;
	FootPrint?: string;
	ExceptionType?: ExceptionType;
	ExternalException?: string;
	InnerException?: IException;
	Message: string;
}

export enum ExceptionType {
	Error = 0,
	Warning = 1,
	Information = 2
}
